/* Naguirre — gaveta "padrão ouro" (03/10/2026): comportamento.
   - setas de "Você também pode gostar";
   - linhas "Cupom" e "Frete" que abrem e fecham (o estado sobrevive ao redesenho da gaveta);
   - cupom num campo igual ao do CEP, aplicado direto no carrinho da Shopify (/cart/update.js com
     "discount"), com a memória dos apps de cupom acertada para eles não reaplicarem o que saiu;
   - consulta de frete pelo CEP, com o mesmo cálculo do checkout (assets/naguirre-frete.js).
   A gaveta é redesenhada pelo tema a cada mudança: tudo aqui usa delegação de eventos e
   reaplica o estado quando o tema avisa (evento "cart-update") ou quando a lista muda.
   05/10/2026 (A03): o cupom virou um módulo com três partes, para servir também à página /cart:
   - NÚCLEO (um carrinho por página): estado dos cupons, a única escrita e uma leitura só para todos os
     painéis;
   - PAINEL: window.NaguirreCupom.montar(raiz, ganchos), uma instância por lugar (a API pública é só essa);
   - ADAPTADOR DA GAVETA (raiz #halo-cart-sidebar): setas, linhas, frete e observadores.
   Na A03 o código só mudou de lugar. O que muda o comportamento na leva 1 está comentado onde fica: frete
   uma vez por carrinho e CEP, com o CEP conferido (T01), reserva igual ao checkout (T21), total à vista em
   tela baixa (T20), gaveta que nunca abre sozinha (T13), regras e textos do cupom (A04, A05, A12 a A17) e
   o painel da página /cart (A02, adaptador em naguirre-carrinho.js).
   06/10/2026 (F1 e F2): com combo no carrinho, o cupom do tema e o do link de consultora não são mais apagados pelo
   Discount On Cart Pro (marcarParaODocp), e uma releitura ~3,5 s depois acerta a tela se o carrinho mudou
   (conferirDepois). */
(function () {
  'use strict';

  function escapar(t) {
    return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function focar(campo) {
    if (campo) setTimeout(function () { try { campo.focus({ preventScroll: true }); } catch (e) { campo.focus(); } }, 50);
  }

  // ===================== Cupom: núcleo (um carrinho por página) =====================
  // Cupons do carrinho como o /cart.js mostra ({ code, applicable }). O Liquid (cart.discount_applications)
  // só enxerga cupom que já desconta nas peças: cupom de FRETE (ex.: GUGAFRETE) não aparece lá, e a linha
  // ficava "Adicionar" com o cupom ativo. Pior: aplicar outro cupom mandava a lista sem ele e o tirava.
  var cuponsCarrinho = null; // null = ainda não lido (vale o que o Liquid mostra)
  var versaoCupons = 0;      // sobe a cada escrita: leitura que começou antes dela chega velha e é descartada
  var LIXO = ['~', 'sd_clear_discount']; // restos dos apps de cupom; não são cupons
  var paineis = [];          // um por lugar (gaveta; no /cart, também a página)

  function guardarCupons(lista) {
    if (!Array.isArray(lista)) return;
    cuponsCarrinho = lista.map(function (d) { return { code: String(d.code || ''), applicable: !!d.applicable, nasPecas: !!d.nasPecas }; })
      .filter(function (c) { return c.code && LIXO.indexOf(c.code.toLowerCase()) === -1; });
  }
  function resumir(c) {
    var NF = window.NaguirreFrete;
    return c && NF && typeof NF.resumirCarrinho === 'function' ? NF.resumirCarrinho(c) : null;
  }
  // F1 e F2 (06/10/2026): com promoção automática no carrinho (o combo), o Discount On Cart Pro (DOCP) apaga com
  // SD_CLEAR_DISCOUNT, ~1 s depois de conferir o carrinho, o cupom que não foi ele quem aplicou: o que soma com a
  // promoção (LIVE10, QUERIDA-…, …AUT), vindo do painel (/cart e gaveta) ou do link de consultora. Ele deixa o cupom
  // quando a sessão tem a marca "docapp-discount-application-detected" (sessionStorage, "1"), relida a cada
  // conferência; ele mesmo só a grava quando a página chama um /discount/ (o caminho da caixa do dcart no C). O tema
  // grava a mesma marca antes de toda escrita de cupom (trocarCupons) e na carga com cupom no carrinho (mais abaixo).
  // A applyCode do DOCP não grava a marca. Sem sessionStorage, fica a releitura (conferirDepois).
  var MARCA_DOCP = 'docapp-discount-application-detected';
  function marcarParaODocp() {
    try { if (sessionStorage.getItem(MARCA_DOCP) !== '1') sessionStorage.setItem(MARCA_DOCP, '1'); } catch (e) {}
  }
  // A ÚNICA escrita de cupom: a lista enviada SUBSTITUI a do carrinho. Os cupons ficam guardados pelo resumo
  // da resposta (05/10/2026, A04/A05): assim "nasPecas" sai certo também logo depois de escrever.
  function trocarCupons(lista) {
    marcarParaODocp(); // F1: antes de escrever
    return fetch('/cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: lista.join(',') })
    }).then(function (r) {
      if (!r.ok) throw new Error('status ' + r.status);
      return r.json();
    }).then(function (carrinho) {
      versaoCupons++;
      var r = resumir(carrinho);
      guardarCupons(r ? r.cupons : carrinho && carrinho.discount_codes);
      return carrinho;
    });
  }
  function lerCookie(nome) {
    var partes = String(document.cookie || '').split(';');
    for (var i = 0; i < partes.length; i++) {
      var p = partes[i].replace(/^\s+/, '');
      if (p.indexOf(nome + '=') === 0) { try { return decodeURIComponent(p.slice(nome.length + 1)); } catch (e) { return p.slice(nome.length + 1); } }
    }
    return '';
  }
  // O cupom tirado não volta (05/10/2026, A04; substitui o acerto que também falava com o dcart). O Discount
  // On Cart Pro (DOCP) guarda os cupons e PÕE DE VOLTA o que some do carrinho; o colar do Dr Free Gift lê o
  // cupom por ele (não desligar). Então, para o código removido:
  // 1. DOCP carregado: a função dele, que só esquece (não manda o SD_CLEAR_DISCOUNT dele ao carrinho);
  // 2. DOCP ainda não carregado (o tema segura os apps até o 1º toque, e o 1º toque pode ser o "Remover"):
  //    escreve na memória que ele lê ao iniciar (formato de docp.fmt.js): a lista de removidos da sessão, os
  //    códigos de localStorage "docapp-coupon" e o cookie "docapp-auto-coupon". Com ele carregado, não: o
  //    estado em memória do app sobrescreveria a escrita;
  // 3. o cookie "discount_code" (link /discount/CÓDIGO), quando é o código removido;
  // 4. o localStorage "discount_code" que não está mais entre os cupons (como antes).
  // Roda no toque e de novo antes de escrever (o 1º toque pode carregar o DOCP no meio).
  function esquecerNosApps(removido, restantes) {
    var CODIGO = String(removido || '').toUpperCase();
    if (!CODIGO) return;
    var baixo = (restantes || []).map(function (c) { return String(c).toLowerCase(); });
    var docp = window.discountOnCartProApp;
    var carregado = !!(docp && (typeof docp.removeCodeWithoutCartDiscountReset === 'function' || typeof docp.removeCode === 'function'));
    try {
      if (docp && typeof docp.removeCodeWithoutCartDiscountReset === 'function') docp.removeCodeWithoutCartDiscountReset(CODIGO);
      else if (docp && typeof docp.removeCode === 'function') docp.removeCode(CODIGO);
    } catch (e) {}
    if (!carregado) {
      try {
        var removidos = JSON.parse(sessionStorage.getItem('docapp-removed-coupons') || '[]');
        if (!Array.isArray(removidos)) removidos = [];
        if (removidos.indexOf(CODIGO) === -1) { removidos.push(CODIGO); sessionStorage.setItem('docapp-removed-coupons', JSON.stringify(removidos)); }
      } catch (e) {}
      try {
        var guardado = JSON.parse(localStorage.getItem('docapp-coupon') || 'null');
        if (guardado && Array.isArray(guardado.codes)) {
          var resto = guardado.codes.filter(function (c) { return String(c).toUpperCase() !== CODIGO; });
          if (resto.length !== guardado.codes.length) { guardado.codes = resto; localStorage.setItem('docapp-coupon', JSON.stringify(guardado)); }
        }
      } catch (e) {}
      try {
        var auto = JSON.parse(lerCookie('docapp-auto-coupon') || 'null');
        if (auto && String(auto.code || '').toUpperCase() === CODIGO) document.cookie = 'docapp-auto-coupon=; Max-Age=0; path=/';
      } catch (e) {}
    }
    try { if (lerCookie('discount_code').toUpperCase() === CODIGO) document.cookie = 'discount_code=; Max-Age=0; path=/'; } catch (e) {}
    try {
      var v = localStorage.getItem('discount_code');
      if (v && baixo.indexOf(v.toLowerCase()) === -1) localStorage.removeItem('discount_code');
    } catch (e) {}
  }
  // O cupom aplicado de novo fica (correção 1, 05/10/2026). O código tirado antes nesta sessão fica na lista de
  // removidos do DOCP ("docapp-removed-coupons": ele a lê ao iniciar e a manda ao servidor dele a cada mudança do
  // carrinho). Com o código no carrinho E na lista, o servidor do DOCP responde "nenhum cupom" e o DOCP apaga o
  // cupom (SD_CLEAR_DISCOUNT) uns 2 s depois (visto depois de recarregar a página e aplicar o mesmo código). Então,
  // para o código que o painel aplica:
  // 1. antes de escrever, sai da lista da sessão (vale para o DOCP que ainda vai carregar);
  // 2. depois da escrita, se o código fica no carrinho, estava na lista e o DOCP já carregou: applyCodes, a função
  //    dele que guarda o código e o tira da lista em memória. Essa chamada confere o carrinho de ANTES da escrita;
  //    o pauseUpdate faz o DOCP ignorar a próxima resposta do servidor dele (vale a conferência da escrita).
  function tirarDaListaDeRemovidos(codigo) {
    var CODIGO = String(codigo || '').toUpperCase();
    try {
      var removidos = JSON.parse(sessionStorage.getItem('docapp-removed-coupons') || '[]');
      if (!Array.isArray(removidos) || removidos.indexOf(CODIGO) === -1) return false;
      sessionStorage.setItem('docapp-removed-coupons', JSON.stringify(removidos.filter(function (c) { return c !== CODIGO; })));
      return true;
    } catch (e) { return false; }
  }
  function lembrarNoDocp(codigo) {
    var CODIGO = String(codigo || '').toUpperCase();
    var docp = window.discountOnCartProApp;
    if (!CODIGO || !docp || typeof docp.applyCodes !== 'function') return;
    try {
      var conhece = Array.isArray(docp.codes) && docp.codes.some(function (c) { return String(c).toUpperCase() === CODIGO; });
      if (conhece) return; // já está nos códigos dele: não está na lista de removidos
      docp.pauseUpdate = true;
      docp.applyCodes([CODIGO]);
    } catch (e) {}
  }
  // Correção 2 (05/10/2026): o link de consultora (/discount/CÓDIGO) põe de volta, na mesma aba, o cupom tirado antes.
  // O link grava o cookie "discount_code", e tirar o cupom pelo painel apaga esse cookie (esquecerNosApps, passo 3):
  // cookie com um código da lista de removidos do DOCP = a cliente pediu o código de novo depois de tirá-lo. Com o
  // código na lista, o DOCP ignora o cookie e apaga o cupom que o link pôs (SD_CLEAR_DISCOUNT). Ele lê a lista ao
  // iniciar, e o tema o segura até o 1º toque, depois deste arquivo: o código sai da lista aqui, na carga de cada
  // página. O "?discount=" do endereço fica de fora de propósito: ele continua no endereço numa recarga, e o cupom
  // tirado voltaria sozinho.
  tirarDaListaDeRemovidos(lerCookie('discount_code'));
  function pedirCupom(codigo, ativos) {
    return trocarCupons(ativos.concat([codigo]));
  }
  function tirarCupom(codigo, ativos) {
    var resto = ativos.filter(function (c) {
      return c.toLowerCase() !== String(codigo).toLowerCase() && c !== '~' && c !== 'SD_CLEAR_DISCOUNT';
    });
    esquecerNosApps(codigo, resto);
    // Correção 1: e de novo logo depois da escrita. Logo depois da carga, o DOCP pode guardar o código (a
    // conferência dele do carrinho de antes volta) enquanto o painel escreve; esquecido aqui, a conferência que
    // ele faz da escrita já sai sem o código.
    return trocarCupons(resto).then(function (c) { esquecerNosApps(codigo, resto); return c; });
  }
  // Regras do campo (05/10/2026): sem espaços; vírgula ou ponto e vírgula = dois cupons de uma vez (A14).
  function normalizar(texto) {
    var codigo = String(texto || '').replace(/\s+/g, '');
    if (!codigo) return { erro: MSG.vazio };
    if (/[,;]/.test(codigo)) return { erro: MSG.umPorVez };
    return { codigo: codigo };
  }
  // Cartão-presente da Shopify: 16 letras e números, sem hífen (A15).
  function pareceVale(codigo) { return /^[a-z0-9]{16}$/i.test(codigo); }
  // Textos do cupom (A13, aprovados em 04/10): M1 a M4 e M11 como antes; M5 a M10 e M12 novos.
  var MSG = {
    vazio: 'Digite o código do cupom.',                                          // M1
    aplicando: 'Aplicando…',                                                     // M2
    jaAplicado: function (c) { return 'O cupom ' + c + ' já está aplicado.'; }, // M3
    aplicado: function (c) { return 'Cupom ' + c + ' aplicado.'; },             // M4
    umPorVez: 'Digite um cupom por vez.',                                        // M5
    naoSoma: function (c) { return 'O cupom ' + c + ' não entrou: ele não se soma à promoção do carrinho ou ainda não vale para este carrinho. A promoção continua aplicada.'; }, // M6
    ficouOMaior: function (c) { return 'Cupom ' + c + ' aplicado. Ele não se soma à promoção, então ficou o desconto do cupom, que é maior.'; }, // M7
    aindaNaoVale: function (c) { return 'O cupom ' + c + ' ainda não vale para este carrinho. Confira o código e se ele tem valor mínimo, vale só para algumas peças ou é pessoal. Ele fica guardado e entra sozinho quando passar a valer.'; }, // M8
    vale: 'Não deu para usar este código como cupom. Se ele é de um vale-presente ou vale-troca, use no pagamento, no campo de código de desconto ou cartão-presente.', // M9
    falhaAplicar: 'Não foi possível aplicar agora. Tente de novo em instantes ou use o cupom no pagamento.', // M10
    removido: function (c) { return 'Cupom ' + c + ' removido.'; },              // M11
    falhaRemover: 'Não foi possível remover agora. Tente de novo em instantes ou remova no pagamento.' // M12
  };
  // Uma leitura do carrinho (250 ms depois do último pedido) para todos os painéis: cada um confere os
  // seus cupons e, se quiser, usa o resumo (a gaveta refaz o frete).
  var esperaCupons = null;
  function agendarLeitura() {
    var NF = window.NaguirreFrete;
    if (!NF || typeof NF.lerCarrinho !== 'function') return;
    clearTimeout(esperaCupons);
    esperaCupons = setTimeout(function () {
      var versao = versaoCupons;
      NF.lerCarrinho().then(function (c) {
        if (versao !== versaoCupons) return;
        paineis.forEach(function (p) {
          p.conferir(c);
          if (typeof p.ganchos.depoisDeLer === 'function') p.ganchos.depoisDeLer(c);
        });
        // Medição (leva E): cupom do link de consultora que esta leitura mostra no carrinho (1 vez por código e visita).
        if (window.ngMedir && window.ngMedir.link) window.ngMedir.link(c, lerCookie('discount_code'));
      }).catch(function () {
        paineis.forEach(function (p) { if (typeof p.ganchos.depoisDeLer === 'function') p.ganchos.depoisDeLer(null); });
      });
    }, 250);
  }
  // F1 e F2 (06/10/2026): a releitura única, ~3,5 s depois (a conferência do DOCP sai logo depois da escrita, ou logo
  // depois que ele entra, e o SD_CLEAR_DISCOUNT ~1 s depois dela). Se um app de cupom mudou o carrinho, a leitura acerta
  // cartões, mensagem e total (o lugar é redesenhado pela diferença). Só quando algum painel mostra o cupom.
  var ESPERA_RELEITURA = 3500;
  function conferirDepois() {
    setTimeout(function () {
      if (paineis.some(function (p) { return p.raiz.querySelector('[data-ng-painel="cupom"]'); })) agendarLeitura();
    }, ESPERA_RELEITURA);
  }
  // F1 e F2, na carga de cada página (o DOCP só entra no 1º toque, depois deste arquivo): cupom no carrinho = o cookie
  // "discount_code" (o link de consultora /discount/CÓDIGO) ou o painel desta página com cupom (o /cart; o Liquid só
  // lista cupom que desconta nas peças, o único que o DOCP apaga). Grava a marca e relê o carrinho ~3,5 s depois de o
  // tema soltar os apps (evento "asyncLazyLoad" de optimization.aio.min.js; script_loaded = já soltou).
  (function () {
    if (!lerCookie('discount_code') && !document.querySelector('[data-ng-cupons-ativos]:not([data-ng-cupons-ativos=""])')) return;
    marcarParaODocp();
    if (window.script_loaded === true) conferirDepois();
    else document.addEventListener('asyncLazyLoad', conferirDepois);
  })();

  // Linha "Cupom" e cartões dos cupons que o Liquid não desenha. Na prática, cupom de frete
  // (vale, mas não desconta nas peças) e cupom que não vale para a sacola (ex.: abaixo do mínimo).
  var ICONE_OK = '<svg viewBox="0 0 20 20" width="16" height="16" aria-hidden="true"><path fill="currentColor" d="M8.2 13.6 4.6 10l-1.2 1.2 4.8 4.8 9-9-1.2-1.2z"/></svg>';

  // ===================== Cupom: painel (uma instância por lugar) =====================
  // ganchos.redesenhar(carrinho?)  redesenha o lugar com o HTML do servidor;
  // ganchos.depoisDeLer(resumo)?   chamado depois de cada leitura do carrinho;
  // ganchos.lembrarMensagem?       (só o /cart) a última mensagem sobrevive 15 s a uma recarga da página;
  // ganchos.regiaoViva?            seletor de uma região aria-live fora do que é redesenhado (anuncia a mensagem);
  // ganchos.terminou()?            chamado quando um aplicar ou remover termina (antes do redesenho).
  var CHAVE_MSG = 'ng-cupom-msg';
  function montar(raiz, ganchos) {
    ganchos = ganchos || {};
    var mensagemCupom = null; // { tipo: 'ok'|'erro'|'aviso', texto } — sobrevive ao redesenho
    var cupomOcupado = false;
    var anunciada = '';
    if (ganchos.lembrarMensagem) {
      // O Discount On Cart Pro pode recarregar o /cart depois de uma troca: a mensagem volta 1 vez.
      try {
        var guardada = JSON.parse(sessionStorage.getItem(CHAVE_MSG) || 'null');
        sessionStorage.removeItem(CHAVE_MSG);
        if (guardada && guardada.texto && Date.now() - guardada.em <= 15000) {
          mensagemCupom = { tipo: guardada.tipo, texto: guardada.texto };
          anunciada = guardada.texto; // volta 1 vez só: não é guardada de novo
          var vivaAgora = ganchos.regiaoViva && document.querySelector(ganchos.regiaoViva);
          if (vivaAgora) vivaAgora.textContent = guardada.texto;
        }
      } catch (e) {}
    }

    function redesenhar(carrinho) {
      if (typeof ganchos.redesenhar === 'function') ganchos.redesenhar(carrinho);
    }
    // Medição (leva E, assets/naguirre-medicao.js): 1 evento no fim de cada aplicar e de cada remover, com o resultado
    // lido da mensagem final (M1 a M12), e 1 quando a releitura desmente a mensagem (cupom_desfeito). O código do cupom
    // não sai daqui: vai só a família. Mensagem que não está na tabela: não mede (nunca inventa).
    var lugar = ganchos.lugar === 'carrinho' ? 'carrinho' : 'gaveta';
    function tipoDoCupom(CODIGO) {
      try {
        var c = (cuponsCarrinho || []).filter(function (x) { return x.code.toUpperCase() === CODIGO; })[0];
        if (c) return c.applicable ? (c.nasPecas ? 'pecas' : 'frete') : 'nenhum';
        // Antes da 1ª leitura vale o Liquid, que só lista cupom que desconta nas peças.
        return !cuponsCarrinho && cuponsAtivos().some(function (x) { return String(x).toUpperCase() === CODIGO; }) ? 'pecas' : 'nenhum';
      } catch (e) { return 'nenhum'; }
    }
    function medirCupom(nome, CODIGO, inicio, extra) {
      var M = window.ngMedir;
      if (typeof M !== 'function') return;
      try {
        var texto = mensagemCupom ? mensagemCupom.texto : '';
        var tabela = nome === 'cupom_removido' ? [[MSG.removido(CODIGO), 'removido'], [MSG.falhaRemover, 'falha']] : [
          [MSG.aplicado(CODIGO), 'aceito', 'aplicado'], [MSG.ficouOMaior(CODIGO), 'aceito', 'ficou_o_maior'],
          [MSG.aindaNaoVale(CODIGO), 'pendente', 'ainda_nao_vale'], [MSG.naoSoma(CODIGO), 'recusado', 'nao_soma'],
          [MSG.vale, 'recusado', 'parece_vale'], [MSG.jaAplicado(CODIGO), 'nada', 'ja_aplicado'],
          [MSG.vazio, 'nada', 'vazio'], [MSG.umPorVez, 'nada', 'um_por_vez'], [MSG.falhaAplicar, 'falha', 'falha']];
        var r = tabela.filter(function (l) { return l[0] === texto; })[0];
        if (!r) return;
        var campos = { lugar: lugar, resultado: r[1], ms: Math.max(0, Math.min(60000, Date.now() - inicio)) };
        if (nome === 'cupom_aplicado') { campos.via = 'digitado'; campos.motivo = r[2]; }
        if (extra && 'combo' in extra) campos.combo = !!extra.combo;
        if (CODIGO) { campos.familia = M.familia(CODIGO); campos.tipo = extra && extra.tipo ? extra.tipo : tipoDoCupom(CODIGO); }
        M(nome, campos);
      } catch (e) {}
    }
    function medirDesfeito(sentido, CODIGO, c) {
      var M = window.ngMedir;
      if (typeof M !== 'function') return;
      try { M('cupom_desfeito', { sentido: sentido, familia: M.familia(CODIGO), lugar: lugar, combo: !!(c && c.promocoes && c.promocoes.length) }); } catch (e) {}
    }
    function cuponsAtivos() {
      if (cuponsCarrinho) return cuponsCarrinho.map(function (c) { return c.code; });
      var el = raiz.querySelector('[data-ng-cupons-ativos]');
      return (el ? el.getAttribute('data-ng-cupons-ativos') : '').split('|').filter(Boolean);
    }
    // Lê o carrinho antes de mexer nos cupons: a lista enviada à Shopify SUBSTITUI a que está lá. Devolve o
    // resumo (cupons e promoções) ou null se a leitura falhou; os cupons ativos ficam em cuponsAtivos().
    function lerFresco() {
      var NF = window.NaguirreFrete;
      if (!NF || typeof NF.lerCarrinho !== 'function') return Promise.resolve(null);
      var versao = versaoCupons;
      return NF.lerCarrinho().then(function (c) {
        if (versao === versaoCupons) guardarCupons(c.cupons);
        return c;
      }, function () { return null; });
    }
    // O lugar pode ter sido desenhado antes de um app de cupom mexer no carrinho (o Discount On Cart Pro
    // reaplica o cupom guardado; visto no teste de 04/10): o /cart.js diz um total e o Liquid outro, ou há
    // cupom descontando nas peças que o Liquid não mostrou. Aí o lugar é redesenhado pelo próprio tema.
    // Sem laço: a mesma diferença nunca pede redesenho duas vezes, e no máximo 6 por minuto.
    var redesenhosForcados = [];
    var ultimaDiferenca = '';
    function pedirRedesenho(diferenca) {
      if (cupomOcupado || diferenca === ultimaDiferenca) return;
      var agora = Date.now();
      redesenhosForcados = redesenhosForcados.filter(function (t) { return agora - t < 60000; });
      if (redesenhosForcados.length >= 6) return;
      redesenhosForcados.push(agora);
      ultimaDiferenca = diferenca;
      redesenhar();
    }
    function conferirCarrinho(c) {
      // T13: lugar ainda não desenhado (a gaveta vazia no /cart, por exemplo): não confere nada, senão um
      // cupom "que falta no Liquid" pediria redesenho e abriria a gaveta por cima da página.
      if (!raiz.querySelector('[data-ng-painel="cupom"]')) return;
      guardarCupons(c.cupons);
      desenharCupons();
      // Correção 1: a mensagem que diz que o cupom ficou (M4, M7, M8) ou saiu (M11) sai quando a leitura mostra o
      // contrário (um app o tirou ou o pôs de volta depois da escrita): o painel não diz o que o carrinho desmente.
      var fica = mensagemCupom && mensagemCupom.fica;
      var saiu = mensagemCupom && mensagemCupom.saiu;
      var tem = function (cod) { return (c.cupons || []).some(function (x) { return String(x.code).toUpperCase() === cod; }); };
      if ((fica && !tem(fica)) || (saiu && tem(saiu))) {
        medirDesfeito(fica && !tem(fica) ? 'sumiu' : 'voltou', fica && !tem(fica) ? fica : saiu, c); // medição
        mensagemCupom = null;
        aplicarMensagemCupom();
      }
      var diferenca = cuponsCarrinho ?c.total + '|' + cuponsCarrinho.map(function (x) { return x.code + (x.nasPecas ? '+' : ''); }).join(',') : '';
      // A02: no /cart, a assinatura do Liquid (total | peças | cupons nas peças) contra a do /cart.js. Só o
      // número de peças mostra que o colar (R$ 0) saiu ou voltou.
      var marcada = raiz.querySelector('[data-ng-assinatura]');
      if (marcada) {
        var nasPecas = (c.cupons || []).filter(function (x) { return x.applicable && x.nasPecas; })
          .map(function (x) { return String(x.code).toLowerCase(); }).sort().join(',');
        if (marcada.getAttribute('data-ng-assinatura') !== c.total + '|' + c.itens + '|' + nasPecas) pedirRedesenho(diferenca + '|' + c.itens);
        return;
      }
      var tema = raiz.querySelector('[data-cart-total-value]');
      var noTema = tema ? parseInt(tema.getAttribute('data-cart-total-value'), 10) : NaN;
      var faltaNoLiquid = (cuponsCarrinho || []).some(function (x) { return x.applicable && x.nasPecas && !cupomNoLiquid(x.code); });
      if ((typeof c.total === 'number' && !isNaN(noTema) && c.total !== noTema) || faltaNoLiquid) pedirRedesenho(diferenca);
    }
    function cupomNoLiquid(codigo) {
      var achou = false;
      raiz.querySelectorAll('.ng-cupom__aplicado:not(.ng-cupom__aplicado--js) [data-ng-remover-cupom]').forEach(function (b) {
        if (String(b.getAttribute('data-ng-remover-cupom')).toLowerCase() === String(codigo).toLowerCase()) achou = true;
      });
      return achou;
    }

    function desenharCupons() {
      if (!cuponsCarrinho) return;
      var resumo = raiz.querySelector('[data-ng-cupom-resumo]');
      var validos = cuponsCarrinho.filter(function (c) { return c.applicable; });
      var texto = validos.length ? validos[0].code.toUpperCase() + ' ✓'
        : cuponsCarrinho.length ? cuponsCarrinho[0].code.toUpperCase() + ' ainda não vale' : 'Adicionar';
      if (resumo && resumo.textContent.trim() !== texto) resumo.textContent = texto;
      var painel = raiz.querySelector('[data-ng-painel="cupom"]');
      if (!painel) return;
      var doLiquid = [];
      painel.querySelectorAll('.ng-cupom__aplicado:not(.ng-cupom__aplicado--js) [data-ng-remover-cupom]').forEach(function (b) {
        doLiquid.push(String(b.getAttribute('data-ng-remover-cupom')).toLowerCase());
      });
      var faltam = cuponsCarrinho.filter(function (c) { return doLiquid.indexOf(c.code.toLowerCase()) === -1; });
      var chave = faltam.map(function (c) { return c.code + (c.applicable ? '+' : '-') + (c.nasPecas ? 'p' : ''); }).join(',');
      if (painel.getAttribute('data-ng-cupons-js') === chave) return; // nada mudou desde o último desenho
      painel.setAttribute('data-ng-cupons-js', chave);
      painel.querySelectorAll('.ng-cupom__aplicado--js').forEach(function (e) { e.remove(); });
      var ancora = painel.querySelector('[data-ng-cupons-ativos]');
      faltam.forEach(function (c) {
        var cartao = document.createElement('div');
        cartao.className = 'ng-cupom__aplicado ng-cupom__aplicado--js' + (c.applicable ? '' : ' is-invalido');
        cartao.innerHTML = '<span class="ng-cupom__codigo">' + (c.applicable ? ICONE_OK : '') +
          '<span class="ng-cupom__nome"><strong>' + escapar(c.code.toUpperCase()) + '</strong><span class="ng-cupom__nota">' +
          (!c.applicable ? 'ainda não vale para este carrinho' : c.nasPecas ? 'aplicado' : 'desconto no frete') + '</span></span></span>' +
          '<button type="button" class="ng-cupom__remover" data-ng-remover-cupom="' + escapar(c.code) + '">Remover<span class="visually-hidden"> cupom ' + escapar(c.code.toUpperCase()) + '</span></button>';
        painel.insertBefore(cartao, ancora);
      });
    }

    function aplicarMensagemCupom() {
      var alvo = raiz.querySelector('[data-ng-cupom-msg]');
      if (!alvo) return;
      var html = mensagemCupom ? '<p class="ng-cupom__' + mensagemCupom.tipo + '">' + escapar(mensagemCupom.texto) + '</p>' : '';
      if (alvo.innerHTML !== html) alvo.innerHTML = html;
      var texto = mensagemCupom && mensagemCupom.texto !== MSG.aplicando ? mensagemCupom.texto : ''; // "Aplicando…" não
      if (texto && texto !== anunciada) {
        anunciada = texto;
        var viva = ganchos.regiaoViva && document.querySelector(ganchos.regiaoViva);
        if (viva) viva.textContent = texto;
        if (ganchos.lembrarMensagem) {
          try { sessionStorage.setItem(CHAVE_MSG, JSON.stringify({ tipo: mensagemCupom.tipo, texto: texto, em: Date.now() })); } catch (e) {}
        }
      }
    }
    function ocupar(sim) {
      cupomOcupado = sim;
      var botao = raiz.querySelector('[data-ng-aplicar]');
      if (botao) botao.disabled = sim;
    }

    // Aplicar (05/10/2026, A05, A12 a A16): lê o carrinho (cupons e promoções), escreve ativos + código e escolhe
    // a mensagem pela resposta:
    //   vale e a promoção saiu (a Shopify ficou com o maior desconto) → M7, fica;  vale → M4, fica;
    //   não vale e parece cartão-presente (16 letras e números) → M9, sai;
    //   não vale e havia promoção → M6, sai (a promoção continua);
    //   não vale, sem promoção → M8, FICA no carrinho ("ainda não vale"): entra sozinho quando passar a valer
    //   e o pagamento confere;  erro de rede ou resposta que não é JSON → M10, sem nova tentativa.
    // Redesenha com o carrinho da última escrita e a mensagem sobrevive ao redesenho.
    function aplicarCupom() {
      var campo = raiz.querySelector('[data-ng-cupom]');
      if (!campo || cupomOcupado) return;
      var inicio = Date.now(); // medição
      var n = normalizar(campo.value);
      if (n.erro) { mensagemCupom = { tipo: 'erro', texto: n.erro }; aplicarMensagemCupom(); medirCupom('cupom_aplicado', '', inicio); return; } // M1, M5: nada é escrito
      var codigo = n.codigo;
      var CODIGO = codigo.toUpperCase();
      function mesmo(c) { return String(c).toLowerCase() === codigo.toLowerCase(); }
      var naLista = tirarDaListaDeRemovidos(CODIGO); // correção 1: antes de escrever (e antes de o DOCP carregar)
      ocupar(true);
      mensagemCupom = { tipo: 'aviso', texto: MSG.aplicando };
      aplicarMensagemCupom();
      var escreveu = false;
      var carrinhoFinal = null;
      var combo = false; // medição: havia promoção automática no carrinho antes
      lerFresco().then(function (antes) {
        combo = !!(antes && antes.promocoes && antes.promocoes.length);
        var ativos = cuponsAtivos();
        if (ativos.some(mesmo)) {
          mensagemCupom = { tipo: 'aviso', texto: MSG.jaAplicado(CODIGO) };
          return null;
        }
        escreveu = true;
        var promosAntes = (antes && antes.promocoes) || [];
        return pedirCupom(codigo, ativos).then(function (carrinho) {
          carrinhoFinal = carrinho;
          var depois = resumir(carrinho) || { cupons: [], promocoes: [] };
          var dele = depois.cupons.filter(function (d) { return mesmo(d.code); })[0];
          // fica: o código que a mensagem diz estar no carrinho (a leitura de depois confere; correção 1).
          if (dele && dele.applicable) {
            var perdeu = promosAntes.some(function (p) { return depois.promocoes.indexOf(p) === -1; });
            mensagemCupom = { tipo: 'ok', texto: perdeu ? MSG.ficouOMaior(CODIGO) : MSG.aplicado(CODIGO), fica: CODIGO };
            if (naLista) lembrarNoDocp(dele.code);
            return null;
          }
          var sai = null;
          if (pareceVale(codigo)) { mensagemCupom = { tipo: 'erro', texto: MSG.vale }; sai = true; }
          else if (promosAntes.length) { mensagemCupom = { tipo: 'erro', texto: MSG.naoSoma(CODIGO) }; sai = true; }
          else mensagemCupom = { tipo: 'aviso', texto: MSG.aindaNaoVale(CODIGO), fica: dele ? CODIGO : null };
          if (!sai && dele && naLista) lembrarNoDocp(dele.code); // M8 fica e entra sozinho quando valer
          if (!sai || !dele) return null;
          return tirarCupom(dele.code, cuponsAtivos().concat([dele.code])).then(function (c) { carrinhoFinal = c; });
        });
      }).catch(function () {
        mensagemCupom = { tipo: 'erro', texto: MSG.falhaAplicar };
      }).then(function () {
        ocupar(false);
        if (mensagemCupom && mensagemCupom.tipo === 'ok') { var c = raiz.querySelector('[data-ng-cupom]'); if (c) c.value = ''; }
        aplicarMensagemCupom();
        medirCupom('cupom_aplicado', CODIGO, inicio, { combo: combo });
        if (typeof ganchos.terminou === 'function') ganchos.terminou();
        // Escrita que falhou (M10): sem redesenho; uma leitura confere se o carrinho mudou mesmo assim
        // (no máximo 3 pedidos ao carrinho, sem nova tentativa).
        if (escreveu && carrinhoFinal) {
          redesenhar(carrinhoFinal);
          // Correção 1 e F1 (06/10/2026): o código ficou no carrinho (M4, M7, M8): a releitura ~3,5 s depois confere se
          // ele continua (o DOCP o apagava com o código na lista de removidos, correção 1, ou com o combo no carrinho,
          // F1) e acerta cartões, total e mensagem. Antes da F1, só com o código na lista.
          if (mensagemCupom && mensagemCupom.fica) conferirDepois();
        }
        else { desenharCupons(); if (escreveu) agendarLeitura(); }
      });
    }

    // Remover (A04): esquece nos apps já no toque, com a lista que o painel conhece, e de novo antes de escrever.
    function removerCupom(codigo) {
      if (cupomOcupado) return;
      ocupar(true);
      var CODIGO = String(codigo).toUpperCase();
      var inicio = Date.now(), tipoAntes = tipoDoCupom(CODIGO); // medição
      // Correção 1: DOCP carregado que ainda não guardou o código (logo depois da carga ele ainda confere o
      // carrinho): ele pode pôr o cupom de volta. Nesse caso, uma leitura ~3 s depois mostra o carrinho como ficou.
      var docp = window.discountOnCartProApp;
      var docpSemOCodigo = !!(docp && typeof docp.removeCodeWithoutCartDiscountReset === 'function' && Array.isArray(docp.codes) &&
        !docp.codes.some(function (c) { return String(c).toUpperCase() === CODIGO; }));
      esquecerNosApps(codigo, cuponsAtivos().filter(function (c) { return c.toLowerCase() !== String(codigo).toLowerCase(); }));
      var carrinhoFinal = null;
      lerFresco().then(function () {
        return tirarCupom(codigo, cuponsAtivos());
      }).then(function (carrinho) {
        carrinhoFinal = carrinho;
        mensagemCupom = { tipo: 'aviso', texto: MSG.removido(CODIGO), saiu: CODIGO };
      }).catch(function () {
        mensagemCupom = { tipo: 'erro', texto: MSG.falhaRemover }; // M12: o cupom continua; sem nova tentativa
      }).then(function () {
        ocupar(false);
        aplicarMensagemCupom();
        medirCupom('cupom_removido', CODIGO, inicio, { tipo: tipoAntes });
        if (typeof ganchos.terminou === 'function') ganchos.terminou();
        if (carrinhoFinal) { redesenhar(carrinhoFinal); if (docpSemOCodigo) setTimeout(agendarLeitura, 3000); }
        else { desenharCupons(); agendarLeitura(); } // M12: o cupom continua; a leitura confere
      });
    }

    raiz.addEventListener('click', function (ev) {
      if (ev.target.closest('[data-ng-aplicar]')) { ev.preventDefault(); aplicarCupom(); return; }
      var remover = ev.target.closest('[data-ng-remover-cupom]');
      if (remover) { ev.preventDefault(); removerCupom(remover.getAttribute('data-ng-remover-cupom')); }
    });
    // Enter no campo faz o mesmo que o botão (não há <form>).
    raiz.addEventListener('keydown', function (ev) {
      if (ev.key !== 'Enter' || !ev.target.matches || !ev.target.matches('[data-ng-cupom]')) return;
      ev.preventDefault();
      aplicarCupom();
    });

    var painel = {
      raiz: raiz,
      ganchos: ganchos,
      ativos: cuponsAtivos,
      conferir: conferirCarrinho,
      desenhar: desenharCupons,
      mensagem: aplicarMensagemCupom,
      limpar: function () { mensagemCupom = null; anunciada = ''; },
      depoisDoRedesenho: function () { aplicarMensagemCupom(); desenharCupons(); agendarLeitura(); }
    };
    paineis.push(painel);
    return painel;
  }
  // temCupomDeFrete (medição, leva E): true/false pela última leitura do carrinho; null antes dela. Só leitura.
  window.NaguirreCupom = {
    montar: montar,
    temCupomDeFrete: function () { return cuponsCarrinho ? cuponsCarrinho.some(function (c) { return c.applicable && !c.nasPecas; }) : null; }
  };

  // ===================== Adaptador da gaveta =====================
  var raiz = document.getElementById('halo-cart-sidebar');
  if (!raiz) return;

  var abertos = { cupom: false, frete: false };

  // ---------- Setas das sugestões ----------
  function passo(lista) {
    var card = lista.querySelector('.ng-sug__card');
    var gap = parseFloat(getComputedStyle(lista).columnGap || getComputedStyle(lista).gap) || 12;
    return card ? card.getBoundingClientRect().width + gap : lista.clientWidth * 0.8;
  }
  function atualizarSetas(bloco) {
    var lista = bloco.querySelector('[data-ng-sug-lista]');
    if (!lista) return;
    var max = lista.scrollWidth - lista.clientWidth - 2;
    bloco.querySelectorAll('[data-ng-sug-seta]').forEach(function (b) {
      var dir = Number(b.getAttribute('data-ng-sug-seta'));
      b.disabled = dir < 0 ? lista.scrollLeft <= 2 : lista.scrollLeft >= max;
    });
  }
  raiz.addEventListener('click', function (ev) {
    var seta = ev.target.closest('[data-ng-sug-seta]');
    if (!seta) return;
    var bloco = seta.closest('[data-ng-sugestoes]');
    var lista = bloco && bloco.querySelector('[data-ng-sug-lista]');
    if (!lista) return;
    lista.scrollBy({ left: Number(seta.getAttribute('data-ng-sug-seta')) * passo(lista), behavior: 'smooth' });
  });
  raiz.addEventListener('scroll', function (ev) {
    if (ev.target && ev.target.matches && ev.target.matches('[data-ng-sug-lista]')) {
      atualizarSetas(ev.target.closest('[data-ng-sugestoes]'));
    } else if (ev.target && ev.target.classList && ev.target.classList.contains('previewCart')) {
      // Lista rolada: aparece a linha sob "Meu Carrinho" (sem ela, o que sobe encostava no título).
      raiz.classList.toggle('ng-lista-rolada', ev.target.scrollTop > 4);
    } else if (ev.target && ev.target.classList && ev.target.classList.contains('previewCartInfo')) {
      marcarRodape();
    }
  }, true);
  // Rodapé que não cabe (painel aberto em tela baixa) rola por trás do "Finalizar a compra", que fica
  // preso embaixo: enquanto houver conteúdo escondido atrás dele, ganha uma sombra em cima.
  function marcarRodape() {
    var r = raiz.querySelector('.previewCartInfo');
    raiz.classList.toggle('ng-rodape-rola', !!(r && r.scrollTop + r.clientHeight < r.scrollHeight - 2));
  }
  window.addEventListener('resize', function () { marcarRodape(); });

  // ---------- Linhas Cupom / Frete (abrir e fechar) ----------
  // A linha inteira é o botão; aberta, ela mostra "Fechar" no lugar do resumo (CSS por aria-expanded).
  function aplicarPaineis() {
    Object.keys(abertos).forEach(function (nome) {
      var painel = raiz.querySelector('[data-ng-painel="' + nome + '"]');
      var botao = raiz.querySelector('[data-ng-abrir="' + nome + '"]');
      if (painel) painel.hidden = !abertos[nome];
      if (botao) botao.setAttribute('aria-expanded', abertos[nome] ? 'true' : 'false');
    });
  }
  raiz.addEventListener('click', function (ev) {
    var botao = ev.target.closest('[data-ng-abrir]');
    if (!botao) return;
    ev.preventDefault();
    var nome = botao.getAttribute('data-ng-abrir');
    abertos[nome] = !abertos[nome];
    if (!abertos[nome] && nome === 'cupom') cupom.limpar(); // fechou: a próxima abertura começa limpa
    aplicarPaineis();
    aplicarMensagemCupom();
    marcarRodape();
    if (abertos[nome]) focar(raiz.querySelector(nome === 'frete' ? '[data-ng-cep]' : '[data-ng-cupom]'));
  });

  // ---------- Cupom: o painel da gaveta ----------
  // T13 (05/10/2026): a gaveta é redesenhada pela função do tema que NÃO a abre (BOGOSHALO, a mesma que o
  // Dr Free Gift e o Discount On Cart Pro chamam): aberta, continua aberta; fechada, continua fechada. Com o
  // carrinho da última escrita, poupa uma leitura. Sem ela, só redesenha com a gaveta já aberta.
  function redesenharGaveta(carrinho) {
    if (typeof window.BOGOSHALO !== 'function') {
      if (document.body.classList.contains('cart-sidebar-show') && typeof window.updateCart === 'function') window.updateCart();
      return;
    }
    if (carrinho && carrinho.items) window.BOGOSHALO(carrinho);
    else if (window.Shopify && typeof window.Shopify.getCart === 'function') window.Shopify.getCart(window.BOGOSHALO);
  }
  var cupom = montar(raiz, {
    redesenhar: redesenharGaveta,
    depoisDeLer: function (resumo) { freteDepoisDoRedesenho(resumo); } // a leitura única decide o frete (T01)
  });
  // Os nomes de antes continuam valendo para o frete e os observadores abaixo.
  var cuponsAtivos = cupom.ativos;
  var conferirCarrinho = cupom.conferir;
  var desenharCupons = cupom.desenhar;
  var aplicarMensagemCupom = cupom.mensagem;

  // ---------- Frete pelo CEP ----------
  // O cálculo é o mesmo do checkout e da página do produto (assets/naguirre-frete.js): a sacola é
  // copiada para um carrinho separado; nada é adicionado ao carrinho da cliente.
  // 05/10/2026 (T01): uma conta por carrinho e CEP. A memória da visita (a mesma da página do produto, 10 min;
  // desde o passo 4 do F6 ela vale para todas as abas) devolve o resultado sem rede quando a chave (CEP, peças,
  // cupons e total) é a mesma: página nova, aba nova, gaveta reaberta. Chave nova: uma conta silenciosa por vez
  // (a que chega durante outra espera fica guardada e só roda se a chave ainda for outra), no máximo 10 por aba,
  // sempre com o CEP gravado (ngCep), que só é gravado depois de um cálculo tocado, conferido e com pelo menos
  // 1 opção. Durante a silenciosa o resumo diz "Calculando…" (nunca "Inserir CEP") e o total "sem frete"; se ela
  // falha, "Calcular", sem erro.
  var cotacaoEmCurso = 0;
  var contasEmVoo = 0;       // contas (tocadas ou silenciosas) que ainda não terminaram
  var proximaSacola = null;  // conta silenciosa pedida durante outra (só a última)
  var ultimo = null; // { assinatura, chave, html, resumo, frete } — devolve o resultado depois de cada redesenho
  var listaNaTela = ''; // a última lista mostrada: fica no painel durante a conta nova e se ela falhar

  // Muda quando muda o que pesa no frete: peças, quantidades, total e cupons que valem. Passo 4 do F6 (05/10/2026):
  // o cupom que ainda não vale (M8 fica no carrinho, sem desconto) não muda peça, total nem frete, e fica de fora
  // (antes, aplicá-lo ou tirá-lo apagava o total com frete até a leitura seguinte). Mesma regra da chave do frete.
  function assinatura() {
    var total = raiz.querySelector('[data-cart-total-value]');
    var cupons = cuponsCarrinho ? cuponsCarrinho.filter(function (c) { return c.applicable; }).map(function (c) { return c.code; }) : cuponsAtivos();
    var partes = [total ? total.getAttribute('data-cart-total-value') : '', cupons.join(',')];
    raiz.querySelectorAll('[data-cart-quantity][data-line]').forEach(function (q) {
      partes.push(q.getAttribute('data-line') + 'x' + q.value);
    });
    return partes.join('|');
  }
  function escreverResumo(t) {
    var resumo = raiz.querySelector('[data-ng-frete-resumo]');
    if (resumo && t && resumo.textContent !== t) resumo.textContent = t;
  }
  // Mesmo formato do total do tema (money_without_trailing_zeros): "R$ 1.234,50", "R$ 150".
  function moeda(c) {
    var reais = String(Math.floor(c / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var cent = c % 100;
    return 'R$\u00a0' + reais + (cent ? ',' + (cent < 10 ? '0' : '') + cent : ''); // \u00a0: "R$" nunca fica sozinho no fim da linha
  }
  // Total: "sem frete" até a cliente calcular. Depois, soma o frete mais barato (a opção que o checkout
  // já abre marcada) e diz qual foi: "com frete de R$ 9,90" / "com frete grátis". Vale só enquanto o
  // carrinho for o mesmo da conta; mudou, volta a "sem frete" até a conta nova chegar. O valor do tema
  // ([data-cart-total-value]) fica intacto e escondido: os apps de cupom escrevem nele.
  function aplicarTotal() {
    var li = raiz.querySelector('[data-ng-total]');
    if (!li) return;
    var sub = li.querySelector('[data-ng-total-sub]');
    var tema = li.querySelector('[data-cart-total-value]');
    var nosso = li.querySelector('[data-ng-total-com-frete]');
    var base = tema ? parseInt(tema.getAttribute('data-cart-total-value'), 10) : NaN;
    var vale = ultimo && typeof ultimo.frete === 'number' && ultimo.assinatura === assinatura() && nosso && !isNaN(base);
    aplicarMetaFrete(vale && ultimo.frete === 0);
    if (!vale) {
      li.classList.remove('is-com-frete');
      if (sub) { sub.textContent = 'sem frete'; sub.classList.remove('is-gratis'); }
      return;
    }
    nosso.textContent = moeda(base + ultimo.frete);
    if (sub) {
      sub.textContent = ultimo.frete === 0 ? 'com frete grátis' : 'com frete de ' + moeda(ultimo.frete);
      sub.classList.toggle('is-gratis', ultimo.frete === 0);
    }
    li.classList.add('is-com-frete');
  }
  // Frete grátis antes da meta (cupom de frete, ex.: GUGAFRETE; o Liquid não enxerga cupom de frete):
  // quando a conta da Shopify dá de graça a opção mais barata, a barra verde diz o mesmo que o total
  // ("Você ganhou frete grátis!", frase do <template> do Liquid). Carrinho mudou: volta ao que era.
  function aplicarMetaFrete(gratis) {
    var meta = raiz.querySelector('[data-ng-meta-frete]');
    if (!meta) return;
    var texto = meta.querySelector('.ng-meta__texto');
    var barra = meta.querySelector('.ng-meta__barra');
    var trilho = meta.querySelector('.ng-meta__trilho');
    var modelo = meta.querySelector('template[data-ng-meta-frete-gratis]');
    if (!texto || !barra || !modelo) return;
    var trocada = meta.classList.contains('is-por-conta');
    if (gratis && !trocada) {
      if (meta.classList.contains('is-completa')) return; // já ganhou pela regra da loja
      meta.__ngAntes = { html: texto.innerHTML, largura: barra.style.width, valor: trilho && trilho.getAttribute('aria-valuenow') };
      texto.innerHTML = modelo.innerHTML;
      barra.style.width = '100%';
      if (trilho) trilho.setAttribute('aria-valuenow', '100');
      meta.classList.add('is-completa', 'is-por-conta');
      if (window.ngMedir && window.ngMedir.freteDoCupom) window.ngMedir.freteDoCupom(meta); // medição: meta_atingida por cupom de frete
    } else if (!gratis && trocada && meta.__ngAntes) {
      texto.innerHTML = meta.__ngAntes.html;
      barra.style.width = meta.__ngAntes.largura;
      if (trilho && meta.__ngAntes.valor != null) trilho.setAttribute('aria-valuenow', meta.__ngAntes.valor);
      meta.classList.remove('is-completa', 'is-por-conta');
    }
  }

  // Resultado na tela (lista, resumo e total): de uma conta ou da memória da aba.
  function mostrar(resultado, marca, chave) {
    var NF = window.NaguirreFrete;
    var barata = NF.maisBarata(resultado);
    var cupomDeFrete = (cuponsCarrinho || []).some(function (x) { return x.applicable && !x.nasPecas; });
    var nota = !resultado.viaCarrinho ? 'mesmos valores do checkout'
      : cupomDeFrete ? 'o desconto do cupom entra no checkout' : 'valores do checkout';
    // T21: a reserva (rota do carrinho) não conhece o desconto do cupom de frete: o frete não entra no total,
    // que fica "sem frete", e a nota diz que o desconto entra no checkout.
    var frete = resultado.viaCarrinho && cupomDeFrete ? null : barata ? barata.centavos : null;
    ultimo = { assinatura: marca, chave: chave, html: NF.desenhar(resultado, nota), resumo: NF.resumo(resultado), frete: frete };
    var alvoAgora = raiz.querySelector('[data-ng-frete-resultado]'); // a gaveta pode ter sido redesenhada
    if (alvoAgora) alvoAgora.innerHTML = ultimo.html;
    listaNaTela = ultimo.html;
    escreverResumo(ultimo.resumo || 'Inserir CEP'); // lista vazia: a cliente confere o CEP
    aplicarTotal();
    marcarRodape();
  }

  // T20 (05/10/2026): em tela baixa (até 600 px de altura; 320 px somam ~5 mil sessões em 30 dias), depois de
  // um cálculo tocado o rodapé, que já rola, desce até o fim da linha do total, 8 px acima do "Finalizar a
  // compra" preso embaixo. Rola só o rodapé (nunca a página) e 1 vez por cálculo. Fora da cadeia da
  // promessa: uma exceção aqui (ex.: o total sumiu porque a gaveta foi redesenhada vazia no meio) cairia no
  // .catch do cálculo e um cálculo certo viraria erro.
  function mostrarTotalEmTelaBaixa() {
    if (!(window.innerHeight <= 600) || typeof window.requestAnimationFrame !== 'function') return;
    requestAnimationFrame(function () {
      try {
        var info = raiz.querySelector('.previewCartInfo');
        var total = raiz.querySelector('[data-ng-total]');
        if (!info || !total) return;
        var acao = raiz.querySelector('.previewCartInfo > .previewCartAction');
        var falta = total.getBoundingClientRect().bottom -
                    (info.getBoundingClientRect().bottom - (acao ? acao.offsetHeight : 0)) + 8;
        if (falta > 0) info.scrollTop += falta;
      } catch (e) {}
    });
  }

  // silencioso: conta que a gaveta faz sozinha (carrinho mudou), sempre com o CEP gravado; sacolaPronta: o
  // resumo da leitura que pediu a conta (poupa uma leitura).
  function calcular(cep, silencioso, sacolaPronta) {
    var NF = window.NaguirreFrete;
    var alvo = raiz.querySelector('[data-ng-frete-resultado]');
    if (!NF || !alvo) return;
    var d = NF.soDigitos(cep);
    // Medição (leva E): frete_calculado só do cálculo tocado que vale, 1 vez (a promessa pode passar pelo .catch depois).
    var inicio = Date.now();
    var medido = silencioso;
    function medirFrete(info) {
      if (medido || !window.ngMedir || !window.ngMedir.frete) return;
      medido = true;
      info.d = d;
      info.inicio = inicio;
      window.ngMedir.frete('gaveta', info);
    }
    if (d.length !== 8) {
      if (!silencioso) alvo.innerHTML = '<p class="ng-frete__erro">Digite os 8 números do CEP.</p>';
      medirFrete({ erro: 'cep' });
      return;
    }
    var painel = raiz.querySelector('[data-ng-painel="frete"]');
    var gratisMin = parseInt(painel && painel.getAttribute('data-gratis-min'), 10) || 0;
    var gratisTeto = parseInt(painel && painel.getAttribute('data-gratis-teto'), 10) || 0;
    var consultar = !painel || painel.getAttribute('data-conferir-cep') !== 'false';
    var minha = ++cotacaoEmCurso;
    var marca = '';
    var chave = '';
    var daMemoria = false;
    var versao = versaoCupons;
    if (!silencioso) alvo.innerHTML = '<p class="ng-frete__aviso">Calculando…</p>';
    else escreverResumo('Calculando…');
    // Tocada: o CEP é conferido (regra local, sem rede; e a ViaCEP) junto com a leitura do carrinho.
    var conferencia = silencioso ? Promise.resolve(d) : NF.conferirCepTocado(d, consultar);
    var leitura = sacolaPronta ? Promise.resolve(sacolaPronta)
      : (!silencioso && NF.cepObvioInvalido(d)) ? null : NF.lerCarrinho();
    contasEmVoo++;
    return Promise.all([conferencia, leitura]).then(function (r) {
      var sacola = r[1];
      if (minha !== cotacaoEmCurso) return null;
      // A leitura também traz os cupons: a assinatura da conta sai com a lista certa.
      if (versao === versaoCupons) conferirCarrinho(sacola);
      marca = assinatura();
      chave = NF.chaveFrete(d, sacola);
      if (!sacola.linhas.length) return null;
      var guardado = NF.lembrado(chave);
      if (guardado) { daMemoria = true; return guardado; } // mesma chave: sem rede
      if (silencioso) NF.contouSozinho();
      return NF.cotar({ linhas: sacola.linhas, cep: d, codigos: sacola.codigos, gratisMin: gratisMin, gratisTeto: gratisTeto })
        .catch(function (e) {
          // A Shopify recusou por um tempo as tarifas pelo caminho novo: usa as do carrinho (rota antiga).
          if (e && e.tipo === 'indisponivel' && typeof NF.cotarPeloCarrinho === 'function') {
            return NF.cotarPeloCarrinho({ cep: d, subtotal: sacola.total, gratisMin: gratisMin, gratisTeto: gratisTeto });
          }
          throw e;
        });
    }).then(function (resultado) {
      if (minha !== cotacaoEmCurso || !resultado) return;
      medirFrete({ resultado: resultado, memoria: daMemoria });
      var temOpcao = !!(resultado.opcoes && resultado.opcoes.length);
      if (temOpcao && !daMemoria) NF.lembrar(chave, resultado);
      if (!silencioso && temOpcao) {
        NF.gravarCep(d);
        NF.gravarCepNoCarrinho(d); // o checkout já abre com o CEP e a UF (1 vez por CEP na aba)
        NF.marcarCalculou();       // a partir daqui, nesta visita, o total da gaveta vem com frete
      }
      // O carrinho mudou durante a conta (app de cupom reaplicando, presente entrando): o resultado é de
      // outro carrinho e não vai para a tela; a leitura que o redesenho agenda pede a conta nova.
      if (marca !== assinatura()) return;
      mostrar(resultado, marca, chave);
      if (!silencioso) mostrarTotalEmTelaBaixa();
    }).catch(function (e) {
      if (minha !== cotacaoEmCurso) return;
      ultimo = null; // sem conta que valha: o total volta a "sem frete"
      aplicarTotal();
      if (silencioso) { escreverResumo('Calcular'); return; } // sem mensagem de erro: a lista anterior fica
      medirFrete({ erro: e && e.tipo === 'cep' ? 'cep' : 'erro' });
      listaNaTela = '';
      escreverResumo('Inserir CEP');
      var alvoAgora = raiz.querySelector('[data-ng-frete-resultado]');
      if (alvoAgora) alvoAgora.innerHTML = '<p class="ng-frete__erro">' + NF.escapar((e && e.message) || 'Não foi possível calcular agora. Tente de novo em instantes.') + '</p>';
    }).then(function () {
      contasEmVoo--;
      if (!contasEmVoo && proximaSacola) {
        var s = proximaSacola;
        proximaSacola = null;
        freteDepoisDoRedesenho(s); // só refaz se a chave ainda for outra
      }
    });
  }

  raiz.addEventListener('input', function (ev) {
    if (ev.target.matches && ev.target.matches('[data-ng-cep]') && window.NaguirreFrete) {
      ev.target.value = window.NaguirreFrete.mascara(ev.target.value);
    }
  });
  raiz.addEventListener('click', function (ev) {
    if (!ev.target.closest('[data-ng-calcular]')) return;
    ev.preventDefault();
    var campo = raiz.querySelector('[data-ng-cep]');
    if (campo) calcular(campo.value, false);
  });
  // Enter no campo do CEP faz o mesmo que o botão (não há <form> na gaveta; o do cupom fica no painel).
  raiz.addEventListener('keydown', function (ev) {
    if (ev.key !== 'Enter' || !ev.target.matches) return;
    if (ev.target.matches('[data-ng-cep]')) { ev.preventDefault(); calcular(ev.target.value, false); }
  });

  // Depois de um redesenho (sacola indefinida) ou de uma leitura do carrinho (sacola = resumo; null se a
  // leitura falhou): mesma conta na tela, devolve; mesma chave na memória da visita, mostra sem rede; chave
  // nova e a cliente já calculou nesta visita (na gaveta ou no produto, nesta aba ou em outra há até 30 min),
  // conta silenciosa. Nunca calcula sozinho para quem não calculou.
  var esperaFrete = null;
  function freteDepoisDoRedesenho(sacola) {
    var NF = window.NaguirreFrete;
    var campo = raiz.querySelector('[data-ng-cep]');
    if (!NF || !campo) return;
    var cep = NF.lerCep();
    if (cep && !campo.value) campo.value = NF.mascara(cep);
    var chave = sacola && cep ? NF.chaveFrete(cep, sacola) : null;
    if (ultimo && ultimo.assinatura === assinatura() && (!chave || ultimo.chave === chave)) {
      var alvo = raiz.querySelector('[data-ng-frete-resultado]');
      if (alvo && !alvo.innerHTML) alvo.innerHTML = ultimo.html;
      escreverResumo(ultimo.resumo);
      aplicarTotal();
      return;
    }
    aplicarTotal();
    if (!cep || !(ultimo || NF.jaCalculou())) return;
    var lugar = raiz.querySelector('[data-ng-frete-resultado]'); // gaveta redesenhada: a lista anterior volta (o total não)
    if (lugar && !lugar.innerHTML && listaNaTela) lugar.innerHTML = listaNaTela;
    if (sacola === undefined) { escreverResumo('Calculando…'); return; } // a leitura agendada decide
    if (!sacola) { if (!contasEmVoo) escreverResumo('Calcular'); return; }
    if (!sacola.linhas.length) return;
    var guardado = NF.lembrado(chave);
    if (guardado) { mostrar(guardado, assinatura(), chave); return; }
    if (contasEmVoo) { proximaSacola = sacola; escreverResumo('Calculando…'); return; }
    if (!NF.podeContarSozinho()) { escreverResumo('Calcular'); return; } // teto de 10 contas sozinhas na aba
    escreverResumo('Calculando…');
    clearTimeout(esperaFrete);
    esperaFrete = setTimeout(function () { calcular(cep, true, sacola); }, 600);
  }

  // ---------- Depois de cada redesenho da gaveta ----------
  function depoisDoRedesenho() {
    var lista = raiz.querySelector('.previewCart');
    raiz.classList.toggle('ng-lista-rolada', !!(lista && lista.scrollTop > 4));
    aplicarPaineis();
    aplicarMensagemCupom();
    desenharCupons();
    agendarLeitura();
    raiz.querySelectorAll('[data-ng-sugestoes]').forEach(atualizarSetas);
    freteDepoisDoRedesenho();
    marcarRodape();
  }
  document.addEventListener('cart-update', function () { setTimeout(depoisDoRedesenho, 0); });
  var lista = raiz.querySelector('.previewCart-wrapper') || raiz;
  var agendado = false;
  new MutationObserver(function () {
    if (agendado) return;
    agendado = true;
    requestAnimationFrame(function () { agendado = false; if (raiz.querySelector('[data-ng-rodape]')) depoisDoRedesenho(); });
  }).observe(lista, { childList: true });
  // Gaveta aberta sem redesenho (o HTML veio com a página): confere os cupons e o frete ao abrir.
  // Também trava a rolagem da PÁGINA enquanto a gaveta está aberta (classe no <html>): o tema só põe
  // overflow hidden no <body>, e como o <html> do tema tem overflow-x hidden, isso não chega à janela.
  // No celular, o dedo na gaveta descia a página do produto por trás (no tema no ar já no 1º arrasto;
  // no rascunho, quando a lista chegava ao fim). Fechou, destrava, e a página fica onde estava.
  var estavaAberta = document.body.classList.contains('cart-sidebar-show');
  document.documentElement.classList.toggle('ng-gaveta-aberta', estavaAberta);
  new MutationObserver(function () {
    var aberta = document.body.classList.contains('cart-sidebar-show');
    if (aberta !== estavaAberta) document.documentElement.classList.toggle('ng-gaveta-aberta', aberta);
    if (aberta && !estavaAberta && raiz.querySelector('[data-ng-rodape]')) { agendarLeitura(); freteDepoisDoRedesenho(); }
    if (!aberta && estavaAberta) {
      // T13: fechou a gaveta: a próxima abertura começa com os painéis fechados e sem a mensagem velha.
      abertos.cupom = abertos.frete = false;
      cupom.limpar();
      aplicarPaineis();
      aplicarMensagemCupom();
    }
    estavaAberta = aberta;
  }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
})();
